import {Edit} from "@mui/icons-material";
import {IconButton} from "@mui/material";
import {DataTableCellProps} from "@variocube/app-ui";
import React from "react";
import {Link} from "react-router-dom";
import {BookingShareWithAppLink} from "../../../api";
import {LinkShareIconButton} from "../../../controls/LinkShareIconButton";
import {useLocalization} from "@smalox/shared";

export interface BookingShareActionCellProps extends DataTableCellProps<BookingShareWithAppLink> {
	canManageBookingAccess: boolean;
}

export function BookingShareActionCell({row, canManageBookingAccess}: Readonly<BookingShareActionCellProps>) {
	const {t} = useLocalization();

	return (
		<>
			<LinkShareIconButton
				title={t("bookings.shares.link.title")}
				text={t("bookings.shares.link.text")}
				url={row.appLink}
			/>
			{canManageBookingAccess && (
				<IconButton component={Link} to={`shares/${row.id}/edit`}>
					<Edit />
				</IconButton>
			)}
		</>
	);
}
